/*
  Behaviour for the Infra Knee Support page, ported from the 1.0.1 design export.

  Differences from the export, all of them consequences of it becoming a real
  product page rather than a standalone file:

  * No nav handler. The export carried its own frosted header; the theme's header
    is used instead.
  * No media lightbox and no gallery rail. Both served the export's hand-built buy
    box, which pdp-main-product replaces.
  * Clips are not base64. The section emits window.IK_ASSETS mapping the export's
    keys to theme asset URLs, which is what data-vsrc resolves against.
  * [data-cart] scrolls to the buy box rather than faking an add. There is one real
    add-to-cart on the page and it belongs to the theme's buy section.
*/
(function () {
  var A = window.IK_ASSETS || {};
  document.querySelectorAll('video[data-vsrc]').forEach(function (v) {
    if (A[v.dataset.vsrc]) v.src = A[v.dataset.vsrc];
  });

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- hero load-in (same curve as the scroll reveal) ---------- */
  var hero = document.querySelector('.ik .hero');
  if (hero) {
    requestAnimationFrame(function () {
      setTimeout(function () {
        hero.classList.add('is-ready');
      }, 60);
    });
  }

  /* ---------- scroll reveal: .ru -> .in (threshold .16, fire once) ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.16 },
    );
    document.querySelectorAll('.ik .ru').forEach(function (el) {
      io.observe(el);
    });
    /* staggered reveal for the four usage moments */
    var mo = document.getElementById('moments');
    if (mo) {
      var io2 = new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) {
              mo.classList.add('reveal-in');
              io2.disconnect();
            }
          });
        },
        { threshold: 0.2 },
      );
      io2.observe(mo);
    }
  } else {
    document.querySelectorAll('.ik .ru').forEach(function (el) {
      el.classList.add('in');
    });
    var m0 = document.getElementById('moments');
    if (m0) m0.classList.add('reveal-in');
  }

  /* ---------- sticky glass CTA: slides up once the hero is out of view ---------- */
  var bar = document.getElementById('gcta');
  if (bar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          bar.classList.toggle('show', !e.isIntersecting);
        });
      },
      { threshold: 0 },
    ).observe(hero);
  }

  /* ---------- every "add to cart" on this page leads to the real one ---------- */
  document.querySelectorAll('.ik [data-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var buy =
        document.getElementById('buy') ||
        document.querySelector('.pdp-redesign-section, #MainProduct, [id^="shopify-section"] .pdp-redesign');
      if (!buy) return;
      buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- contoured-fit loop: only runs while it is on screen ---------- */
  (function () {
    var v = document.getElementById('benVid');
    if (!v) return;
    if (RM) {
      try {
        v.pause();
      } catch (e) {}
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            try {
              v.pause();
            } catch (err) {}
          }
        });
      },
      { threshold: 0.2 },
    ).observe(v);
  })();

  /* ---------- product reveal: starts on entry, then loops ----------
     The `loop` attribute lives on the markup in sections/infra-knee-body.liquid.
     Because of it the `ended` handler below never fires, so `is-done` (and with it
     the replay button) only ever appears on the prefers-reduced-motion path, where
     nothing autoplays. Both are kept for exactly that case. */
  (function () {
    var stage = document.getElementById('revealStage'),
      vid = document.getElementById('revealVid'),
      rep = document.getElementById('revealReplay');
    if (!stage || !vid) return;
    function play() {
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
    }
    vid.addEventListener('ended', function () {
      stage.classList.add('is-done');
    });
    if (rep) {
      rep.addEventListener('click', function () {
        stage.classList.remove('is-done');
        vid.currentTime = 0;
        play();
      });
    }
    if (RM) {
      stage.classList.add('is-done');
      return;
    }
    if ('IntersectionObserver' in window) {
      var once = false;
      new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && !once) {
              once = true;
              play();
            }
          });
        },
        { threshold: 0.45 },
      ).observe(stage);
    } else {
      play();
    }
  })();

  /* ---------- everyday-use clip: only runs while it is on screen ---------- */
  (function () {
    var v = document.getElementById('cineVid');
    if (!v || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            try {
              v.pause();
            } catch (err) {}
          }
        });
      },
      { threshold: 0.1 },
    ).observe(v);
  })();

  /* ---------- DJI-style scroll expansion (everyday-use block) ---------- */
  (function () {
    var sc = document.getElementById('cineScroll'),
      md = document.getElementById('cineMedia'),
      ct = document.getElementById('cineContent');
    if (!sc || !md) return;
    if (RM) {
      md.style.transform = 'none';
      md.style.borderRadius = '0';
      if (ct) {
        ct.style.opacity = 1;
        ct.style.transform = 'none';
      }
      return;
    }
    var tick = false;
    function frame() {
      tick = false;
      var r = sc.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var p = Math.min(1, Math.max(0, -r.top / total));
      var grow = Math.min(1, p / 0.62),
        e = 1 - Math.pow(1 - grow, 3);
      md.style.transform = 'scale(' + (0.7 + 0.3 * e) + ')';
      md.style.borderRadius = 16 * (1 - e) + 'px';
      if (ct) {
        var tp = Math.min(1, Math.max(0, (p - 0.42) / 0.3));
        ct.style.opacity = tp;
        ct.style.transform = 'translateY(' + 26 * (1 - tp) + 'px)';
      }
    }
    function onS() {
      if (!tick) {
        tick = true;
        requestAnimationFrame(frame);
      }
    }
    window.addEventListener('scroll', onS, { passive: true });
    window.addEventListener('resize', onS);
    frame();
  })();

  /* ---------- carousel: drag, arrows, dots ---------- */
  function carousel(tid, pid, nid, did, gid) {
    var tr = document.getElementById(tid);
    if (!tr) return;
    var pv = document.getElementById(pid),
      nx = document.getElementById(nid),
      dd = did ? document.getElementById(did) : null,
      gb = gid ? document.getElementById(gid) : null,
      dots = [];
    var items = tr.children;
    if (dd) {
      for (var k = 0; k < items.length; k++) {
        var d = document.createElement('span');
        d.className = 'feat__dot';
        dd.appendChild(d);
      }
      dots = [].slice.call(dd.querySelectorAll('.feat__dot'));
    }
    function step() {
      var c = tr.children[0];
      return c ? c.getBoundingClientRect().width + 16 : 420;
    }
    function sync() {
      /* map dots to scroll progress, not to card index: the last screenful shows
         several cards at once, so an index-based dot can never reach the end */
      var max = tr.scrollWidth - tr.clientWidth;
      if (dots.length) {
        var i = max > 4 ? Math.round((tr.scrollLeft / max) * (items.length - 1)) : 0;
        i = Math.max(0, Math.min(items.length - 1, i));
        dots.forEach(function (d, k) {
          d.classList.toggle('is-on', k === i);
        });
      }
      /* Progress bar, same mechanics as the homepage bestsellers carousel
         (assets/home-carousel.js): a segment one slide wide, moved with `left`
         rather than a transform so it cannot sub-pixel against the track. */
      if (gb) {
        var seg = 100 / Math.max(1, items.length);
        gb.style.width = seg + '%';
        gb.style.left = (max > 4 ? (tr.scrollLeft / max) * (100 - seg) : 0) + '%';
      }
      if (pv) pv.disabled = tr.scrollLeft < 10;
      if (nx) nx.disabled = tr.scrollLeft > max - 10;
    }
    if (pv) {
      pv.addEventListener('click', function () {
        tr.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (nx) {
      nx.addEventListener('click', function () {
        tr.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    tr.addEventListener(
      'scroll',
      function () {
        requestAnimationFrame(sync);
      },
      { passive: true },
    );
    var down = false,
      sx = 0,
      sl = 0,
      moved = false;
    tr.addEventListener('pointerdown', function (e) {
      down = true;
      moved = false;
      sx = e.clientX;
      sl = tr.scrollLeft;
      tr.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 4) moved = true;
      tr.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      tr.classList.remove('is-drag');
    });
    tr.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true,
    );
    sync();
  }
  carousel('ftrack', 'featPrev', 'featNext', 'featDots');
  /* Contour trio: a slider below 860px only. On desktop it is a 3-up grid, not
     scrollable, so sync() disables both arrows and the controls are hidden. */
  carousel('benTrack', 'benPrev', 'benNext', null, 'benProgress');

  /* ---------- bento detail popups ---------- */
  (function () {
    var BD = window.IK_BENTO || {};
    var bm = document.getElementById('bmodal'),
      bmM = document.getElementById('bmodalMedia'),
      bmT = document.getElementById('bmodalTitle'),
      bmX = document.getElementById('bmodalText'),
      bmC = document.getElementById('bmodalClose');
    if (!bm) return;
    function bClose() {
      bm.classList.remove('open');
      bm.setAttribute('aria-hidden', 'true');
      bmM.classList.remove('show');
      bmM.style.backgroundImage = '';
      document.body.style.overflow = '';
    }
    bmC.addEventListener('click', bClose);
    bm.addEventListener('click', function (e) {
      if (e.target === bm) bClose();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') bClose();
    });
    document.querySelectorAll('.ik [data-bento]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        var d = BD[tile.dataset.bento];
        if (!d) return;
        bmT.textContent = d.t;
        bmX.innerHTML = d.p
          .map(function (x) {
            return '<p>' + x + '</p>';
          })
          .join('');
        if (d.img) {
          bmM.style.backgroundImage = "url('" + d.img + "')";
          bmM.classList.add('show');
        }
        bm.classList.add('open');
        bm.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
  })();

  /* ---------- reduced motion: hold videos on their first frame ---------- */
  if (RM) {
    document.querySelectorAll('.ik video').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.addEventListener('loadeddata', function () {
        try {
          v.pause();
        } catch (e) {}
      });
    });
  }
})();
